import React, { useEffect } from "react";
import Header from "../../../Components/Header/Header";
import dummy1 from "../SignificanceOfNarasimha/assets/dummy1.jpg";
// import NityaSeva from "./assets/Nitya Seva.png";
import NityaSeva from "../assets/0O4A6439.webp";
import Footer from "../../../Components/Footer/Footer";
import RecentBlogs from "../RecentBlogs/RecentBlogs";
import "./nityaSevaBlog.css";
import { Helmet } from "react-helmet-async";

const NityaSevaBlog = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Nitya Seva – Daily Seva Opportunities at ISKCON Vijayawada | Support
          Temple Services
        </title>
        <meta
          name="description"
          content="Contribute to Nitya Seva at ISKCON Vijayawada and be part of daily temple services. Learn how your offerings help maintain daily worship and spiritual activities."
        />
        <meta
          name="keywords"
          content="Nitya Seva ISKCON Vijayawada,Daily seva offerings ISKCON,ISKCON Vijayawada donations,Temple seva opportunities,Support ISKCON temple services,Daily pooja contributions,How to contribute to Nitya Seva at ISKCON Vijayawada,Benefits of Nitya Seva in ISKCON temples Daily temple service donations Vijayawada"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Nitya Seva – Daily Seva Opportunities at ISKCON Vijayawada | Support Temple Services"
        />
        <meta
          property="og:description"
          content="Contribute to Nitya Seva at ISKCON Vijayawada and be part of daily temple services. Learn how your offerings help maintain daily worship and spiritual activities."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/nitya-seva-blog"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Nitya Seva – Daily Seva Opportunities at ISKCON Vijayawada | Support Temple Services"
        />
        <meta
          name="twitter:description"
          content="Contribute to Nitya Seva at ISKCON Vijayawada and be part of daily temple services. Learn how your offerings help maintain daily worship and spiritual activities."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/nitya-seva-blog"
        />
      </Helmet>
      <Header />
      <div className="  flex justify-center items-center flex-col w-full h-full  pb-14">
        <div className="heading-sign flex justify-center items-center text-2xl md:text-4xl md:font-bold bg-[#c61d21]">
          <h1>
            Join the Nitya Seva Program at ISKCON Vijayawada – Serve Lord
            Krishna Daily
          </h1>
        </div>

        <main className="significance-blog">
          <div className="main-section">
            <div className="banner-img">
              <img src={NityaSeva} alt="dummy1" />
            </div>

            <div id="text-content">
              <h1>Nitya Seva: A Monthly Offering, An Eternal Connection</h1>
              <br />
              <h3 className="text-gray-500">
                Serve Supreme Daily at ISKCON Vijayawada
              </h3>
              <br />
              <h4>
                <b>Nitya Seva: A Monthly Offering, An Eternal Connection</b>
              </h4>
              <br />

              <p>
                Have you ever wondered how beautifully everything is organized
                during{" "}
                <b>
                  <a href="http://www.iskconvijayawada.org/">
                    ISKCON Vijayawada
                  </a>{" "}
                  temple festivals
                </b>
                —be it the{" "}
                <b>
                  altar decoration seva, preparation of prasadam, spiritual
                  lectures,
                </b>{" "}
                or <b>soulful kirtan?</b> It all feels so seamless and
                well-coordinated.
              </p>

              <p>
                While our dedicated monks and temple team work tirelessly to
                make this possible, there is also a group of silent contributors
                working behind the scenes—our <b>Nitya Sevaks</b>. These are
                devotees who engage in{" "}
                <b>daily devotional service at ISKCON temple</b> through the{" "}
                <b>Nitya Seva ISKCON Vijayawada </b>program. Their humble and
                consistent <b>monthly seva offerings</b> play a vital role in
                maintaining the spiritual energy of the temple.
              </p>

              <p>
                By becoming a <b>Nitya Sevak</b>, you can also participate in{" "}
                <b>daily seva at ISKCON Vijayawada</b>—serving{" "}
                <b>Lord Krishna</b> through offerings, volunteering during
                festivals, or supporting <b>prasadam distribution</b> and{" "}
                <b>spiritual service activities</b>. Whether it’s offering your
                time, energy, or resources, your{" "}
                <b>monthly service to Lord Krishna in ISKCON</b> becomes a
                lasting connection with the divine.
              </p>

              <p>
                Interested in{" "}
                <b>volunteer opportunities in ISKCON Vijayawada</b>? Join the{" "}
                <b>Nitya Seva program</b> today and be part of the{" "}
                <b>behind-the-scenes temple service</b> that brings spiritual
                joy to thousands of devotees.
              </p>
              <br />

              <h2>Who is a Nitya Sevak?</h2>
              <p>
                A **Nitya Sevak** is a devotee who chooses to offer a monthly
                contribution towards the daily services of the temple. But it’s
                not just a donation—it’s a sacred act of **devotion and
                surrender to the Lord**.
              </p>
              <p>
                As Lord Krishna lovingly declares in **Bhagavad Gita 9.31**:
              </p>
              <p>
                “Those who serve Me with love and dedication are very dear to
                Me, and I promise that My devotee never perishes.”
              </p>
              <p>
                By becoming a Nitya Sevak, you become part of the temple’s daily
                worship and offerings, no matter where you are.
              </p>
              <br />

              <h2>
                What Is Nitya Seva and Why Does It Matters?{" "}
                <span className="text-gray-500">
                  Why Join the Nitya Seva Program?
                </span>
              </h2>

              <p>
                Srila Prabhupada has said that any service or offering made to
                Krishna with a sincere heart becomes **spiritually eternal**—it
                stays with the soul even after this life.
              </p>
              <p>
                “Serving the Deities with love is as good as serving Krishna
                directly.”
              </p>

              <p>
                By joining the Nitya Seva program you: <br />
                - Help maintain the Lord’s daily worship <br />
                - Purify your heart through regular devotional service <br />
                - Stay spiritually connected with the temple <br />- Support the
                spreading of Krishna consciousness{" "}
              </p>

              <p>
                This is a beautiful opportunity to bring Krishna into your
                everyday life.
              </p>

              <br />
              <h2>Monthly Seva Options:</h2>
              <p>
                You can choose a seva that suits your devotion and capacity.
                Every offering, whether big or small, holds great spiritual
                significance when offered with love.
              </p>

              <p>
                - Sampurna Seva – A complete offering that supports multiple
                aspects of temple service. <br />
                - Ekadashi Seva – A special offering on the most spiritually
                potent day of the month. <br />
                - Vaishnav Bhojan Seva – Help provide prasadam to devotees and
                visitors. <br />
                - Maha Aarthi Seva – Be part of the grand daily aarthi for the
                Lord. <br />- Andaan Seva – Support the free prasadam
                distribution for all. <br />
                - Gau Seva – Serve and protect the holy cows, loved dearly by
                Lord Krishna. <br />
                - Nivedana Seva – A humble and regular offering to the Lord’s
                daily services. <br />- Pushpa Seva – Offer beautiful flowers
                for the Lord’s pleasure. <br />
                - MahaRaja Bhog Seva – Sponsor a royal offering of food to the
                Lord. <br />
                - Jaya Vijaya Seva – Support the overall functioning and upkeep
                of the temple. <br />
                <br />
                Choose the seva that speaks to your heart, and be a part of
                something eternal.{" "}
              </p>

              <p>
                <h1>How Your Seva is Used:</h1>
                Your monthly contribution supports **five key areas of
                service**: <br />
                <br />
                1. Sri Vigraha Seva – Daily worship and dressing of the Deities{" "}
                <br />
                2. Prasadam Distribution – Feeding devotees and guests with
                sanctified food <br />
                3. Sadhu Seva – Serving monks and spiritual teachers <br />
                4. Temple Maintenance – Ensuring a clean, serene, and divine
                space <br />
                5. Spiritual Education – Conducting spiritual discourses,
                classes, and outreach programs <br />
                <br />
                Your offering helps keep the temple vibrant, alive, and
                spiritually impactful.
              </p>
              <br />

              <p>
                {" "}
                <h2>How to Offer Your Nitya Seva</h2>
                Bank Transfer (NEFT/RTGS) <br />
                - Account Name: ISKCON <br />
                - Account Number: 50100436709020 <br />
                - IFSC Code: HDFC000568 <br />
                - Bank Name: HDFC Bank <br />
                - Branch: ONE TOWN, VIJAYAWADA <br />
                UPI Transfer <br />
                UPI ID: ISCKONVIJAYAWADA@IDFCBANK <br />
                After You Donate : Please send your transaction details or
                screenshot via WhatsApp to: <br />
                +91 99556 85568, This helps us acknowledge your seva and send
                you a receipt that qualifies for tax <br />
                exemption under Section 80G of the Income Tax Act. <br />
                <br />
                <h2>Make Every Month Count in Krishna’s Service</h2>
                <br />
                By becoming a **Nitya Sevak**, you are not just donating—you are
                offering love, care, and devotion to Lord <br />
                Krishna. It is a divine opportunity to stay spiritually
                connected while supporting a sacred cause. <br />
                <br />
                “Let your monthly offering become a daily blessing. Join the
                Nitya Seva family and serve Krishna with love.”
              </p>
            </div>
          </div>

          <div id="side-bar-section" className="blog-2">
            <RecentBlogs />
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default NityaSevaBlog;
